// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"366":"b894d9a5","924":"8441e126","952":"5d8ab033","987":"677d4221"}[chunkId] + ".chunk.js";
};